import React, { useState, useEffect, useCallback } from 'react';
import api from '../../utils/api';

export default function AdminCustomers() {
  const [customers, setCustomers] = useState([]);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    const params = { page, limit: 50 };
    if (search) params.search = search;
    api.get('/customers/admin/all', { params }).then(r => { setCustomers(r.data.customers || []); setTotal(r.data.total || 0); }).catch(() => {}).finally(() => setLoading(false));
  }, [page, search]);

  useEffect(() => { load(); }, [load]);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 800, color: '#1a2744', marginBottom: 2 }}>Customers</h1>
          <p style={{ color: '#9a9a9a', fontSize: 13 }}>{total} registered accounts</p>
        </div>
        <input className="form-control" style={{ maxWidth: 260 }} placeholder="Search name or email..." value={search} onChange={e => { setSearch(e.target.value); setPage(1); }} />
      </div>

      <div style={{ background: '#fff', borderRadius: 12, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.07)' }}>
        {loading ? <div className="loading"><div className="spinner" /></div> : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#f8f7f2', borderBottom: '2px solid #e8e8e8' }}>
                {['Name','Email','Phone','Joined'].map(h => (
                  <th key={h} style={{ padding: '12px 16px', textAlign: 'left', fontSize: 12, fontWeight: 700, color: '#9a9a9a', textTransform: 'uppercase', letterSpacing: '0.05em' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {customers.length === 0 ? <tr><td colSpan={4} style={{ textAlign: 'center', padding: 40, color: '#9a9a9a' }}>No customers found</td></tr>
              : customers.map(c => (
                <tr key={c.id} style={{ borderBottom: '1px solid #f4f4f4' }}>
                  <td style={{ padding: '12px 16px', fontWeight: 700, color: '#1a2744', fontSize: 14 }}>{c.first_name} {c.last_name}</td>
                  <td style={{ padding: '12px 16px', fontSize: 13, color: '#555' }}>{c.email}</td>
                  <td style={{ padding: '12px 16px', fontSize: 13, color: '#555' }}>{c.phone || '—'}</td>
                  <td style={{ padding: '12px 16px', fontSize: 12, color: '#9a9a9a' }}>{new Date(c.created_at).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
